<!--
 * @Auther: 罗耀祖
 * @Date: 2021-07-27 13:41:26
 * @LastEditors: 罗耀祖
 * @LastEditTime: 2022-05-05 11:01:26
 * @name: 选择穿梭框可选
 * @Description: 选择穿梭框可选
 * @FilePath: \preSaleNafterSaleBackstage\src\components\pianoCompanyManage\jurisdiction-set.vue
 * @Author: DESKTOP-1QU67QM
-->
<template>
  <div class="jurisdictionSet">
    <el-tree
      :data="jurisdiction.catagoryGoods"
      show-checkbox
      node-key="union_id"
      ref="tree"
      highlight-current
      :props="props"
      @check="checkChange"
    >
    </el-tree>
  </div>
</template>
<script>
import { debounceation } from "@/utils/decorator";
export default {
  name: "jurisdictionSet",
  props: {
    jurisdiction: {
      type: Object,
    },
  },
  data() {
    return {
      props: {
        label: "name",
        children: "children",
        isLeaf: "leaf",
      },
      defKeys: [],
    };
  },
  watch: {
    "jurisdiction.is_change": {
      handler(nv, ov) {
        if (nv !== ov) {
          let newVal = this.jurisdiction.treeDataGet.map((x) => x.union_id);
          this.$refs.tree.setCheckedKeys(newVal);
        }
      },
      immediate: false,
      deep: true,
    },
  },
  created() {
    this.jurisdiction.getCatagoryGoods();
  },
  methods: {
    @debounceation(300)
    checkChange(a, b) {
      this.jurisdiction.checkNodeChange(
        b.checkedNodes.filter((x) => x.level === 4)
      );
    },
  },
};
</script>
<style lang="scss" scoped>
.jurisdictionSet {
  width: 100%;
  height: 100%;
  padding: 10px;
  box-sizing: border-box;
  overflow-y: auto;
}
</style>